import { useObjectTranslation } from './useObjectTranslation';

export const useErrorTranslation = (enable: boolean, error: any) => {
  const { t } = useObjectTranslation('common');

  /**
   * Empty string ' ' is required to take spaces above inputs
   */
  return !error && enable ? ' ' : t(error);
};
